import transferDetail from './transfer-detail.vue'

export default transferDetail
